// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import { initialState } from './initialState'

import {
  ADD_ANTENNA_SETTINGS,
  ADD_FREQUENCY_SETTINGS,
  ADD_REGULATORY_SETTINGS,
  ADD_RADIO_SETTINGS,
} from './types'

const domain = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ANTENNA_SETTINGS :
      return state.merge(
        fromJS({
          antennaApplications: action.antennaApplications,
          antennaClassifications: action.antennaClassifications,
          antennaCompanies: action.antennaCompanies,
          antennaCompliances: action.antennaCompliances,
          antennaStatuses: action.antennaStatuses,
          antennaPatternPolarizations: action.antennaPatternPolarizations,
          antennaPolarizations: action.antennaPolarizations,
        })
      )

    case ADD_FREQUENCY_SETTINGS :
      return state.set('frequencySettings', fromJS(action.settings))

    case ADD_REGULATORY_SETTINGS :
      return state.set('regulatorySettings', fromJS(action.settings))

    case ADD_RADIO_SETTINGS :
      return state.set('radioSettings', fromJS(action.settings))

    default :
      return state
  }
}

export default domain
